import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Princess_Tower.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Princess Tower</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>One of the world's tallest residential towers at 414 metres — a defining landmark on the Dubai Marina skyline comprising 763
                apartments across 101 floors. Princess Tower was the world's tallest residential building upon its completion in 2012.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : ETA</p>
              <p>GEMCO SCOPE OF WORKS : MEP works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one